export const ERRORS = {
  '00006421': 'Temperature sensor error/City power version',
  '00006030': 'SD error',
  '00028000': 'Door status error',
}
